import React, { Component } from 'react';
import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import ExportingData from 'highcharts/modules/export-data';
import moment from 'moment';
import { renderAutoCompleteScheduling, renderAutoCompleteSingleSelect, renderCheckBox, renderDateField } from '../components/reduxFields';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { RaisedButton } from 'material-ui';

Exporting(Highcharts);
ExportingData(Highcharts);

class TrendlineGraph extends Component {

    constructor(props) {
        super(props);
        this.state = {
            xAxisDateOption: [],
            isReset: false,
            // isSelected: this.props.isSelected
        };
    }


    componentDidMount = () => {
        this.highchartsHandler();
    }

    componentDidUpdate = () => {
        if (this.props.dataAnalytics !== null) {
            this.highchartsHandler();
        }
    }

    _getTrendLine(data) {
        const n = data.length;
    
        let sumX = 0,
            sumY = 0,
            sumXY = 0,
            sumX2 = 0;
    
        // Calculate the sums needed for linear regression
        for (let i = 0; i < n; i++) {
            const [x, y] = data[i];
            sumX += x;
            sumY += y;
            sumXY += x * y;
            sumX2 += x ** 2;
        }
    
        // Calculate the slope of the trend line
        const slope = (n * sumXY - sumX * sumY) / (n * sumX2 - sumX ** 2);
    
        // Calculate the intercept of the trend line
        const intercept = (sumY - slope * sumX) / n;
    
        const trendline = []; // Array to store the trend line data points
    
        // Find the minimum and maximum x-values from the scatter plot data
        const minX = Math.min(...data.map(([x]) => x));
        const maxX = Math.max(...data.map(([x]) => x));
    
        // Calculate the corresponding y-values for the trend line using the slope
        // and intercept
        trendline.push([minX, minX * slope + intercept]);
        trendline.push([maxX, maxX * slope + intercept]);
    
        return trendline;
    }
    


    highchartsHandler = () => {
        let disableLegend = this.props.disableLegend;
        let gridlinesWidth = this.props.hideGridlines ? 0 : 1;
        let xAxisLabel = 'Billable Hours';    
        let yAxisLabel = 'Date';
        let finalData = [];
        let billableHourId = [];
        let xAxisDateBeforeSorting = [];
        let xAxisDate = [];
        let avgPlotLine = {}; //seriesSum = 0, seriesCount = 0,
        let totalhours = 0;  



        let trendData = [];


        if(this.props.dataAnalytics !== null && this.props.dataAnalytics.data != null && this.props.dataAnalytics.data.patientBillableHoursGraphs != null && this.props.dataAnalytics.data.patientBillableHoursGraphs.length > 0) {
            let data = this.props.dataAnalytics.data.patientBillableHoursGraphs;
            
            data.forEach(obj=>{
                // console.log("obj-->",obj);
                // console.log("dateObj.y-->", dateObj.y);
                let dateOfService = obj.dateOfService;
                let dateObj = new Date(dateOfService);
                let year = dateObj.getFullYear();
                let month = dateObj.getMonth();
                let date = dateObj.getDate();
                let y = obj.y
                let secondArry = [];
                secondArry.push(Date.UTC(year,month,date));
                secondArry.push(y);
                trendData.push(secondArry);
                // finalData.push([Date.UTC(year,month,date),y]);
            })
            
            // console.log("patientBillableHoursGraph", data);
            // console.log("trendData",trendData);
        }

        // console.log("trendData",trendData);
        let trendLine = this._getTrendLine(trendData);
        let averageLine = this.props.averageLine ? this.props.averageLine : [];




              
        if (this.props.dataAnalytics !== null && this.props.dataAnalytics.data != null && this.props.dataAnalytics.data.patientBillableHoursGraphs != null && this.props.dataAnalytics.data.patientBillableHoursGraphs.length > 0) {
            this.props.dataAnalytics.data.patientBillableHoursGraphs.map((obj, index) => {

              if(obj.reportType === 'ByMonth')
              {
                let dataObj = {}
                let billableHours = [];
                let billableHoursdataForDate = this.props.dataAnalytics.data.patientBillableHoursGraphs;
                for (let i = 0; i < billableHoursdataForDate.length; i++) {
                    if(xAxisDateBeforeSorting.indexOf(moment(billableHoursdataForDate[i].dateOfService).format('MMM/yyyy')) === -1)
                    {
                        xAxisDateBeforeSorting.push(moment(billableHoursdataForDate[i].dateOfService).format('MMM/yyyy'));
                    }
                }

                xAxisDateBeforeSorting.sort((dateA, dateB) => new Date(dateA) - new Date(dateB));

                for(let j = 0; j < xAxisDateBeforeSorting.length; j++)
                {  
                    xAxisDate[j] = moment(xAxisDateBeforeSorting[j]).format('MMM/yyyy');
                }

                if(billableHourId.indexOf(obj.billableHourId) === -1)
                {
                    let appointmentdata = this.props.dataAnalytics.data.patientBillableHoursGraphs.filter((op) => op.billableHourId === obj.billableHourId);
                    billableHours = [];
                    for (let i = 0; i < appointmentdata.length; i++) {
                        dataObj['name'] = appointmentdata[i].title;
                        dataObj['billableHourId'] = appointmentdata[i].billableHourId;
                        billableHourId.push(appointmentdata[i].billableHourId);
                        if(xAxisDate.indexOf(moment(appointmentdata[i].dateOfService).format('MMM/yyyy')) > -1)
                        {
                            let index = xAxisDate.indexOf(moment(appointmentdata[i].dateOfService).format('MMM/yyyy'));
                            billableHours[index] = parseFloat(appointmentdata[i].y);
                            totalhours = totalhours + parseFloat(appointmentdata[i].y);
                            // billableHours.push(appointmentdata[i].billableHours);
                            // seriesSum += parseFloat(appointmentdata[i].billableHours);
                            // seriesCount += 1;
                        }
                    }

                    for(let j = 0; j < xAxisDate.length; j++)
                    {
                        //if(!billableHours[j])
                        if(billableHours[j] === undefined || billableHours[j] < 0)
                        {
                          billableHours[j] = null;
                        }
                    }

                    if (this.state.sliderMaxValue !== Math.max(...billableHours)) {                    
                        this.setState({sliderMaxValue: Math.max( ...billableHours), sliderValue: Math.max( ...billableHours)});                        
                    }
                    dataObj['data'] = billableHours;
                    finalData.push(dataObj);
                }
              }
              else {
                let dataObj = {}
                let billableHours = [];
                let billableHoursdataForDate = this.props.dataAnalytics.data.patientBillableHoursGraphs;
                for (let i = 0; i < billableHoursdataForDate.length; i++) {
                    if(xAxisDateBeforeSorting.indexOf(moment(billableHoursdataForDate[i].dateOfService).format('MM/DD/YYYY')) === -1)
                    {
                        xAxisDateBeforeSorting.push(moment(billableHoursdataForDate[i].dateOfService).format('MM/DD/YYYY'));
                    }
                }

                xAxisDateBeforeSorting.sort((dateA, dateB) => new Date(dateA) - new Date(dateB));

                for(let j = 0; j < xAxisDateBeforeSorting.length; j++)
                {  
                    xAxisDate[j] = moment(xAxisDateBeforeSorting[j]).format('MM/DD/YYYY');
                }

                if(billableHourId.indexOf(obj.billableHourId) === -1)
                {
                    let appointmentdata = this.props.dataAnalytics.data.patientBillableHoursGraphs.filter((op) => op.billableHourId === obj.billableHourId);
                    billableHours = [];
                    for (let i = 0; i < appointmentdata.length; i++) {
                        dataObj['name'] = appointmentdata[i].title;
                        dataObj['billableHourId'] = appointmentdata[i].billableHourId;
                        billableHourId.push(appointmentdata[i].billableHourId);
                        if(xAxisDate.indexOf(moment(appointmentdata[i].dateOfService).format('MM/DD/YYYY')) > -1)
                        {
                            let index = xAxisDate.indexOf(moment(appointmentdata[i].dateOfService).format('MM/DD/YYYY'));
                            billableHours[index] = parseFloat(appointmentdata[i].y);
                            totalhours = totalhours + parseFloat(appointmentdata[i].y);
                            // billableHours.push(appointmentdata[i].billableHours);
                            // seriesSum += parseFloat(appointmentdata[i].billableHours);
                            // seriesCount += 1;
                        }
                    }

                    for(let j = 0; j < xAxisDate.length; j++)
                    {
                        //if(!billableHours[j])
                        if(billableHours[j] === undefined || billableHours[j] < 0)
                        {
                          billableHours[j] = null;
                        }
                    }

                    if (this.state.sliderMaxValue !== Math.max(...billableHours)) {                    
                        this.setState({sliderMaxValue: Math.max( ...billableHours), sliderValue: Math.max( ...billableHours)});                        
                    }
                    dataObj['data'] = billableHours;
                    finalData.push(dataObj);
                }
              }



            });

        }

        if(xAxisDate.length && this.state.xAxisDateOption.length != xAxisDate.length)
            {
                let xAxisDate1 = [];

                xAxisDate1 = xAxisDate.map((d,i)=>{
                    return {
                        'id':i,
                        'value':d.toString()
                    }
                })

                this.setState({xAxisDateOption: xAxisDate1}
                    ,()=>{ this.setState({})}
                    );           
            }

        finalData.reverse();
        //////////////////////////////////////////////
        // if(this.props.isSelected){
            Highcharts.setOptions({
                lang: {
                    thousandsSep: ','
                },
                colors: ['#058DC7', '#50B432', '#ED561B', '#DDDF00', '#24CBE5', '#64E572', '#FF9655', '#FFF263', '#6AF9C4']
            });
    
            Highcharts.chart('trandlineGraph', {
    
                // title: {
                //     text: 'Trend Line'
                // },
                title: {
                    text: 'Total Hour(s): ' + totalhours.toFixed(2)
                },
                //annotations: this.state.AnnotationLabel,
                yAxis: {
                    // title: {
                    //     text: 'Y Axis'
                    // },
                    gridLineWidth: gridlinesWidth,
                    minorGridLineWidth: gridlinesWidth,
                    title: {
                    text: `<b>${xAxisLabel}</b>`
                    },
                    labels: {
                        enabled: true
                    },
                    min: 0,
                    max: this.props.sliderValue
                    // plotLines: [avgPlotLine]
                },
                legend: {
                    layout: 'vertical',
                    align: 'right',
                    verticalAlign: 'middle',
                    enabled: disableLegend,
                },
    
                xAxis: {
    
                    type: 'datetime', // Treat the X-axis as dates
                    // title: {
                    //     text: 'Date'
                    // },
                    title: {
                        text: `<b>${yAxisLabel}</b>`,
                    },
                    tickLength: 0,
                    // categories: xAxisDate,
                    labels: {
                        rotation: -45,
                        formatter: function() {
                            return Highcharts.dateFormat('%m/%d/%Y', this.value);
                        },
                        enabled: true
                    }
                    //plotLines: this.state.BaselineLabel,
                },
    
                credits: {
                    enabled: false
                },
    
                plotOptions: {
                    series: {
                        cursor: 'pointer',
                        connectNulls: true,
                        //connectNulls: this.state.BaselineLabel.length > 0 ? false : true,
                        fillOpacity: 0.6,
                        label: {
                            connectorAllowed: false
                        },
                        dataLabels: {
                            enabled: false
                        },
                        events: {
                            legendItemClick: function () {
                                return false
                            }
                        },
                        marker: {
                            enabled: true
                        }
                    }
                },
    
                series: [{
                    type: 'line',
                    name: 'Trend Line',
                    data: trendLine,
                    marker: {
                        enabled: false
                    }
                },{
                    // type: 'scatter',
                    type: 'line',
                    name: 'Observations',
                    data: trendData, 
                    marker: {
                        radius: 4
                    }
                },
                {
                    type: 'line', // Set the type to 'line' for the average line
                    name: 'Average',
                    data: averageLine,
                    marker: 
                    {
                        radius:4
                    },
                }
            ],
                responsive: {
                    rules: [{
                        condition: {
                            maxWidth: 500
                        },
                        chartOptions: {
                            legend: {
                                layout: 'horizontal',
                                align: 'center',
                                verticalAlign: 'bottom',
                                enabled: disableLegend,
                            }
                        }
                    }]
                },
    
                navigation: {
                    buttonOptions: {
                        verticalAlign: 'top',
                        x: -100
                    }
                },
    
                lang: {
                    contextButtonTitle: 'Click to open'
                },
    
                exporting: {
                    buttons: {
                        contextButton: {
                            menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "downloadCSV", "downloadXLS"]
                        }
                    },
                    chartOptions: {
                        colors: ['#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000'],
                    }
                }
            });
    }

    render() {
        return (
            // <div>
            //     <div className='row'>
                        // <div className='col-sm-11'>
                            <div>
                                {
                                    this.props.loading ? "Loading..." :
                                        <div>
                                            <div id='trandlineGraph' 
                                            style={{ height: '500px' }}
                                            />
                                        </div>
                                }
                            </div>
                        // </div>
            //     </div>
            // </div>
        )
    }
}

export default TrendlineGraph;


// WEBPACK FOOTER //
// ./src/adminCharts/TrendlineGraph.js